/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class ProjectType implements Serializable<ProjectType> {
    type: string;
    deleted: boolean;
    id: string;
    name: string;
    label: string;

    deserialize(input: any) {
        input.type && (this.id = input.type);
        input.type && (this.name = input.type);
        input.type && (this.type = input.type);
        input.deleted && (this.deleted = input.deleted);
        input.type && (this.label = input.type);
        return this;
    }

    constructor() {
    }

}
